import { number, shape } from 'prop-types';
import { useTheme } from 'styled-components';

import { toCurrency } from 'utils/number';

const YAxisTick = ({ x = 0, y = 0, payload, width }) => {
  const theme = useTheme();

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={x - 2 * width}
        y={0}
        dy={5}
        fill={theme.new.colors.neutral800}
        fontSize={14}
        fontWeight={theme.fontWeights.semiBold}
        fontFamily={theme.new.fontFamily}
        textAnchor="end"
      >
        {toCurrency(payload.value)}
      </text>
    </g>
  );
};

YAxisTick.propTypes = {
  payload: shape({ value: number }),
  width: number,
  x: number,
  y: number
};

export default YAxisTick;
